import React from "react";
import ColorsList, { ColorRectange } from "./ColorsList";
import Popover from "@material-ui/core/Popover";

export default function ColorsListDropDown({
  onChange,
  value,
  colors,
  isShowArrowDropDownIcon = false,
  isColorsListDisabled = false,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleChange = (e) => {
    setAnchorEl(null);
    onChange(e);
  };

  return (
    <>
      <ColorRectange
        color={value}
        onClick={(e) => {
          if (!isColorsListDisabled) {
            setAnchorEl(e.currentTarget);
          }
        }}
        isShowArrowDropDownIcon={isShowArrowDropDownIcon}
        isDefaultCursor={isColorsListDisabled}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <ColorsList colors={colors} value={value} onChange={handleChange} />
      </Popover>
    </>
  );
}
